import { Component, ViewChildren, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Wrapper } from 'src/app/components/wrapper.component';
import { AccessType, AccessTypeKeys, EVENT_PERMISSIONS } from 'globals/store/permissions.data';
import { ManageSessionStates } from './../../store/reselectors/sessions.reselector';
import { WorkerWithProfile } from 'globals/store/workforce.data';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'change-permission-dialog',
    template: `
      <div class="permission_dialog joi-dialog">
          <div mat-dialog-content>
              <h3>Permissions <span *ngIf="worker">for {{worker.firstName}} {{worker.lastName}}</span></h3>
              <mat-radio-group [disabled]="is_saving" name="level" class="level_group align_options_top" [(ngModel)]="permissions_model" required>
                  <mat-radio-button disableRipple="true" color="primary" class="level" *ngFor="let level of selectable_permission_levels" [value]="level.handle" [disabled]="level.disabled">
                      <div class="label"><b>{{level.label}}</b></div>
                      <div class="desc">{{level.desc}}</div>
                  </mat-radio-button>
              </mat-radio-group>
          </div>
          <mat-progress-bar *ngIf="loading && !is_saving" mode="indeterminate" color="primary"></mat-progress-bar>
          <div mat-dialog-actions>
              <button mat-button (click)="dialogRef.close()" [disabled]="is_saving">CANCEL</button>
              <div style="flex:1;"></div>
              <mat-progress-spinner [diameter]="25" *ngIf="is_saving" mode="indeterminate" color="primary"></mat-progress-spinner>
              <button mat-button color="primary" (click)="save()" [disabled]="loading || is_saving">SAVE</button>
          </div>
      </div>
`,
    styleUrls: [`./workforce.main.scss`],
    standalone: true,
    imports: [MatProgressBarModule, MatProgressSpinnerModule, MatRadioModule, CommonModule, FormsModule, ],
})
export class ChangePermissionsDialogComponent extends Wrapper<ChangePermissionsDialogComponent> {

  readonly _file: string = 'workforce.dialog.ts';
  hold_values;
  loading = false;
  db_restrictions
  worker;
  is_saving = false;
  permissions_model: AccessType 
  permissions_on_init: AccessType 
  selectable_permission_levels = []
  @ViewChildren('togglePrivilege') togglePrivilege;

  constructor(public dialogRef: MatDialogRef<ChangePermissionsDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: ChangePermissionsDialogData) {
    super()
    const { currentPermissions, workerWithProfile, isLogistics } = data

    this.permissions_on_init = currentPermissions[0]
    this.permissions_model = currentPermissions[0]
    this.worker = workerWithProfile

    this.selectable_permission_levels = Object.keys(EVENT_PERMISSIONS).map(key=>EVENT_PERMISSIONS[key]).filter(level=>level.selectable_level).filter(level => !isLogistics || level.handle !== 'program')
  }

  save() {
    if (this.permissions_on_init === this.permissions_model) {
      this.dialogRef.close();
      return;
    }
    this.is_saving = true;
    this.loading = true;
    setTimeout(_ => {
      this.permissionsService.saveRestrictionsFor(this.data.uid_or_email, { types: [this.permissions_model] }).then(() => {
        this.is_saving = true;
        this.dialogRef.close()
      }).catch(response => {
        this.is_saving = false;
        this.logService.error({
          file: this._file,
          function: 'ChangePermissionsDialogComponent ngOnInit saveRestrictionsFor',
          response,
          error: new Error(),
          data: { uid_or_email: this.data.uid_or_email }, message: 'Error setting permissions for workforce member'
        });
      })
    }, 0)
  }
}

export interface ChangePermissionsDialogData {
  uid_or_email: string
  isLogistics: boolean
  currentPermissions: AccessType[]
  workerWithProfile: WorkerWithProfile
}